import {
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import LeadCampaignApi from "../../../../../infrastructure/api/leadCampaignApi";
import MarketGrowthPageShell from "../components/MarketGrowthPageShell";

const PerformanceTable = ({ title, rows }) => (
  <Paper sx={{ p: 2, mb: 3 }}>
    <Typography variant="subtitle1" sx={{ mb: 2 }}>
      {title}
    </Typography>
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>عنوان</TableCell>
            <TableCell align="right">مخاطب</TableCell>
            <TableCell align="right">ثبت‌نام</TableCell>
            <TableCell align="right">درخواست</TableCell>
            <TableCell align="right">نرخ ثبت‌نام %</TableCell>
            <TableCell align="right">نرخ درخواست %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows?.length ? (
            <TableRow>
              <TableCell colSpan={6}>داده‌ای موجود نیست.</TableCell>
            </TableRow>
          ) : (
            rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.title}</TableCell>
                <TableCell align="right">{row.contactCount ?? 0}</TableCell>
                <TableCell align="right">{row.registeredCount ?? 0}</TableCell>
                <TableCell align="right">
                  {row.requestedCount ?? row.projectRequestCount ?? 0}
                </TableCell>
                <TableCell align="right">{row.registrationRate ?? 0}</TableCell>
                <TableCell align="right">
                  {row.requestRate ?? row.projectRequestRate ?? 0}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

const LeadCampaignReportsPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await LeadCampaignApi.getReports();
      const normalized = LeadCampaignApi.normalize(res, "بارگذاری گزارش‌ها ناموفق بود.");
      if (normalized.error) {
        setError(normalized.error);
        setData(null);
        return;
      }
      setData(normalized.data);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <MarketGrowthPageShell
      title="گزارش کمپین‌ها"
      description="عملکرد کمپین‌ها و گروه‌های مخاطب."
      loading={loading}
      error={error}
      onRetry={load}
    >
      {data?.conversionDelayNote ? (
        <Alert severity="info" sx={{ mb: 3 }}>
          {data.conversionDelayNote}
        </Alert>
      ) : null}
      <PerformanceTable title="عملکرد کمپین‌ها" rows={data?.campaigns || data?.Campaigns} />
      <PerformanceTable title="عملکرد گروه‌ها" rows={data?.groups || data?.Groups} />
    </MarketGrowthPageShell>
  );
};

export default LeadCampaignReportsPage;
